import { reconcile } from "solid-js/store";

import {
  getRepeatDetails,
  postGetActivityDetails,
  postGetBonusSummaryData,
} from "@/api/clientApi/activity";
import { GetMyTaskActivityInfo } from "@/api/clientApi/task";
import { wagerContestActList } from "@/constants/constants";
import { usePropsInit } from "@/hooks/useProps";
import { setLocalStorageItem } from "@/lib/localStorage";
import {
  activityStore,
  getRepeatActivity,
  setActivityDetailsMap,
} from "@/stores/activityStore";
import {
  SumData,
  getSpecialActivityRewards,
  initAllDetail,
  setBonusCenterStore,
  updateOneActivityDetail,
} from "@/stores/bonusCenterStore";
import { userStore } from "@/stores/userStore";
import {
  ActivityTypeEnum,
  BonusCategoryConfig,
  BonusCategoryCtrl,
  BonusCategoryType,
} from "@/types/compontent/base/baseEnum";

// 主函数
export function useBounsCenterInit() {
  const getPropsItemData = async (update: boolean = false) => {
    usePropsInit()
      .getUserPromoItemList()
      .then(() => {
        if (update) {
          updateOneActivityDetail(ActivityTypeEnum.propsItem);
        }
      });
  };
  // 将异步操作包装在一个函数中
  const initData = () => {
    if (!userStore.isLogin) {
      return;
    }

    GetMyTaskActivityInfo().then((res) => {
      if (res) {
        setBonusCenterStore("taskList", reconcile([...(res?.list || [])]));
      }
    });
    //先获取道具数据
    getPropsItemData();
    getAllActivityDetails();
    getSpecialActivityRewards();
  };

  // 直接调用初始化函数
  return { initData, getPropsItemData };
}

export const getBonusSummaryData = async () => {
  const summaryData = await postGetBonusSummaryData();
  const maps = summaryData?.total || {};
  let totalActivity = 0;
  let totalVip = 0;
  let totalSpecial = 0;
  let totalAll = 0;
  let totalWagerContest = 0;
  const list: [string, number][] = Object.entries(maps);
  list.map((item) => {
    const bonus_category = Number(item[0]);
    if (wagerContestActList.includes(bonus_category)) {
      totalWagerContest += item[1];
    }
    totalAll += item[1];
    if (BonusCategoryConfig[bonus_category] == BonusCategoryCtrl.Normal) {
      totalActivity += item[1];
    } else if (BonusCategoryConfig[bonus_category] == BonusCategoryCtrl.Vip) {
      totalVip += item[1];
    } else {
      totalSpecial += item[1];
    }

    return {
      type: item[0],
      point: item[1],
    };
  });
  activityStore.bonusCategoryList.forEach((el: number) => {
    if (!maps[el]) {
      maps[el] = 0;
    }
  });
  const specialHistoryMaps = { ...maps }; // 创建副本而不是引用

  // 删除所有投注比賽和當前支持类型活动以外的键值对
  Object.keys(specialHistoryMaps).forEach((key) => {
    if (wagerContestActList.includes(Number(key))) {
      delete specialHistoryMaps[key];
    }
  });

  specialHistoryMaps[BonusCategoryType.DailyRace] = totalWagerContest; // 投注比賽总和
  let hasSpecial = false;
  const typeList =
    Object.keys(specialHistoryMaps).map((el: string) => {
      if (Number(el) == BonusCategoryType.Special) {
        hasSpecial = true;
      }
      return Number(el);
    }) || [];
  typeList.sort((a, b) => (a > b ? 1 : -1));
  if (!hasSpecial) {
    typeList.push(BonusCategoryType.Special);
  }
  const specialHistoryTypeList = [...typeList];

  const sum: SumData = {
    totalActivity,
    specialHistoryTypeList,
    totalVip,
    totalSpecial,
    totalAll,
    specialHistoryMaps,
  };
  setBonusCenterStore("bonusSumaryData", reconcile(sum));
};

// 防抖：避免短时间内重复调用
let lastCallTime = 0;
const DEBOUNCE_DELAY = 1000; // 1秒内的重复调用会被忽略

export const getAllActivityDetails = async () => {
  const now = Date.now();
  // 如果在时间内重复调用，则忽略
  if (now - lastCallTime < DEBOUNCE_DELAY) {
    console.log("[getAllActivityDetails] 防抖：忽略重复调用");
    return;
  }
  lastCallTime = now;

  const list = activityStore.allOpenActivity;

  // 优惠活动
  const repeatList = getRepeatActivity();

  const details = await postGetActivityDetails({ atypes: list }, false);
  const repeatDetails = await getRepeatDetails({ atypes: repeatList });

  // 针对 92 活动第一次初始的情况, 目前只有 92 活动需要处理 (爛需求)
  const inviteeNumber =
    details?.activity_details?.["92"]?.details?.incr_ticket_num_invitee;

  const result = {};
  for (const key in details?.activity_details) {
    result[key] =
      details?.activity_details[key as keyof typeof details]?.details
        ?.first_sync_detial_today || false;
  }

  setLocalStorageItem("92_inviteeNumber", inviteeNumber);
  setLocalStorageItem("activity_details_first_sync", result);

  setActivityDetailsMap({
    ...details?.activity_details,
    ...repeatDetails?.activity_details,
  });
  initAllDetail();
  return { ...details?.activity_details, ...repeatDetails?.activity_details };
};
